export const GET_REGISTER_LOCATIONS = 'GET_REGISTER_LOCATIONS'
export const GET_PROVINCES = 'GET_PROVINCES'
